import { Link } from "react-router-dom";

interface CheckoutDisclaimerProps {
  exampleAmount?: string;
  notes?: string[];
}

const CheckoutDisclaimer = ({ exampleAmount, notes }: CheckoutDisclaimerProps) => {
  return (
    <div className="mt-6 pt-4 border-t border-border">
      <div className="text-left">
        {exampleAmount && (
          <p className="text-sm font-medium mb-2 text-foreground">
            {exampleAmount}
          </p>
        )}
        
        {notes && notes.length > 0 && (
          <ul className="mb-3 space-y-1">
            {notes.map((note, index) => (
              <li key={index} className="text-xs font-body" style={{ color: '#777' }}>
                • {note}
              </li>
            ))}
          </ul>
        )}
        
        <p className="text-xs font-body" style={{ color: '#777' }}>
          Flexaura is a marketplace, not a lender. Financing is provided by licensed BNPL providers, banks, or finance companies. Eligibility, interest rates, and limits are determined by partners. If a customer defaults, liability rests with the financing provider.
        </p>
        <div className="mt-2 space-x-1">
          <Link 
            to="/privacy" 
            className="text-xs font-body underline hover:no-underline"
            style={{ color: '#777' }}
          >
            Privacy Policy
          </Link>
          <span className="text-xs" style={{ color: '#777' }}>•</span>
          <Link 
            to="/terms" 
            className="text-xs font-body underline hover:no-underline"
            style={{ color: '#777' }}
          >
            Terms of Service
          </Link>
        </div>
      </div>
    </div>
  );
};

export default CheckoutDisclaimer;